export default Object.freeze({
    orderStatusUpdate:'ORDER_STATUS_UPDATE',
    orderEdit: 'ORDER_EDIT',
    createQuote: 'QUOTE_CREATE',
    updateQuote: 'QUOTE_UPDATE',
});